// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GmMgP","content":"styles_content__2tKxT","tableWrap":"styles_tableWrap__dLAk3"};